export type HandleFunction = (i: string, s: string) => Promise<void>;

export type ProfileProgress = {
    label: string;
    variant: string;
    value: number;
};

export type FeatureFlags = 
  'ai.presentation' |
  'ai.multi-reports' |
  'ai.usage-report' |
  'mx.approval' |
  'mx.unlock' |
 // 'mx.dynamic_formula' |
  'mx.client_rpt' |
  'aws.communication' |
  // 'rpt.stop_loss' |
  'rpt.stop_loss_campaign' |
  'rpt.stop_loss_budget' |
  'rpt.stop_loss_budget_row' |
  'rpt.dashboard_periods' |
  'rpt.media_dashboard2' |
  'rpt.creatives_report' |
 // 'st.accounts_channels' |
  'st.3rd_party_auth' |
  // 'se.notifications' |
  'se.features';

export type UserProfile = {
    id?: string;
    name?: string;
    role?: string;
    email?: string;
    // isAdmin?: boolean;
    isSystemAdmin?: boolean;
    isDeveloper?: boolean;
    permissions?:PermissionTypeEnum[];
    company?: string; // { Name : string, Logo: string };
    avatar?: string;
    logo?: string;
    features?:FeatureFlags[];
    // image?: string;
    // work_email?: string;
    // about?: string;
    // personal_email?: string;
    // phone?: string;
    // work_phone?: string;
    // personal_phone?: string;
    // birthdayText?: string;
    // lastMessage?: string;
    // status?: string;
    // friends?: number;
    // followers?: number;
    // contact?: string;
     
    // location?: string;
    // online_status?: string;
    // unReadChatCount?: number;
    // groups?: Group[];
    // time?: string;
    // tier?: string;
    // Progress?: ProfileProgress;
};

export enum PermissionTypeEnum
        {
            None = 0,
            Admin = 1,
            GeneralSettings = 2,
            AccountCreateDelete = 3,
            OperationalReports = 4,
            ManagementReports = 5,
            MediaPlanApprover = 6,
            ClientZone = 7
        };

export type Profile = {
    id: string;
    avatar: string;
    name: string;
    time: string;
};

export type PostImage = {
    img: string;
    featured?: boolean;
    title?: string;
};

export type Likes = {
    like: boolean;
    value: number;
};

export type Group = {
    id: string;
    avatar: string;
    name: string;
};

export type Reply = {
    id: string;
    profile: Profile;
    data: CommentData;
};

export type CommentData = {
    name?: string;
    comment?: string;
    likes?: Likes;
    video?: string;
    replies?: Reply[];
};

export type PostData = {
    id?: string;
    content: string;
    images: PostImage[];
    video?: string;
    likes: Likes;
    comments?: Comment[];
};
export type Comment = {
    id: string;
    profile: Profile;
    data?: CommentData;
};
export type Post = {
    id?: string;
    profile: Profile;
    data: PostData;
};

export type PostDataType = { id: string; data: PostData; profile: Profile };

export interface PostProps {
    commentAdd: (s: string, c: Reply) => Promise<void>;
    handleCommentLikes: HandleFunction;
    editPost?: HandleFunction;
    renderPost?: HandleFunction;
    setPosts?: React.Dispatch<React.SetStateAction<PostDataType[]>>;
    handlePostLikes: (s: string) => Promise<void>;
    handleReplayLikes: (postId: string, commentId: string, replayId: string) => Promise<void>;
    post: PostDataType;
    replyAdd: (postId: string, commentId: string, reply: Reply) => Promise<void>;
}
